/**
 * Gift With Purchase — Tiered Auto-Add/Remove
 *
 * Exposes GiftSync.getUpdates(cart) which returns any gift changes needed.
 * The caller (cart.js, cart-drawer.js, product-form.js) can batch these
 * into their existing cart API call for zero extra round trips.
 */

window.GiftSync = {
  getTiers: function() {
    var el = document.querySelector('free-gift');
    if (!el) return [];
    var tiers = [];
    var fields = [
      { id: 'tier1ProductId', variant: 'tier1VariantId', threshold: 'tier1Threshold' },
      { id: 'tier2ProductId', variant: 'tier2VariantId', threshold: 'tier2Threshold' }
    ];
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      var pid = el.dataset[f.id];
      var vid = el.dataset[f.variant];
      var thr = parseInt(el.dataset[f.threshold] || '0', 10);
      if (pid && vid && thr > 0) {
        tiers.push({ productId: parseInt(pid, 10), variantId: parseInt(vid, 10), threshold: thr });
      }
    }
    return tiers;
  },

  /**
   * Given current cart data, returns an updates object for /cart/update.js
   * with any gift variant ID changes needed (add=1 or remove=0).
   * Returns null if no changes needed.
   */
  getUpdates: function(cart) {
    var tiers = this.getTiers();
    if (tiers.length === 0) return null;

    var giftIds = tiers.map(function(t) { return t.productId; });
    var subtotal = 0;
    cart.items.forEach(function(item) {
      if (giftIds.indexOf(item.product_id) === -1) subtotal += item.final_line_price;
    });

    var updates = {};
    var hasChanges = false;

    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      var inCart = null;
      for (var j = 0; j < cart.items.length; j++) {
        if (cart.items[j].product_id === tier.productId) { inCart = cart.items[j]; break; }
      }
      var qualified = subtotal >= tier.threshold;
      var dismissed = sessionStorage.getItem('gift_dismissed_' + tier.productId);

      if (qualified && !inCart && !dismissed) {
        updates[tier.variantId] = 1;
        hasChanges = true;
      } else if (!qualified && inCart) {
        updates[inCart.variant_id] = 0;
        sessionStorage.removeItem('gift_dismissed_' + tier.productId);
        hasChanges = true;
      } else if (inCart && inCart.quantity > 1) {
        updates[inCart.variant_id] = 1;
        hasChanges = true;
      }
    }

    return hasChanges ? updates : null;
  },

  /**
   * Predict subtotal after a quantity change, to determine gift state
   * before the API call happens.
   */
  predictUpdates: function(cart, changeLine, changeQty) {
    var tiers = this.getTiers();
    if (tiers.length === 0) return null;

    var giftIds = tiers.map(function(t) { return t.productId; });

    // Simulate the cart after the change
    var subtotal = 0;
    cart.items.forEach(function(item, idx) {
      if (giftIds.indexOf(item.product_id) !== -1) return; // skip gifts
      var lineNum = idx + 1; // 1-based
      var qty = (lineNum === changeLine) ? changeQty : item.quantity;
      if (qty > 0) {
        subtotal += (item.final_line_price / item.quantity) * qty;
      }
    });

    var updates = {};
    var hasChanges = false;

    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      var inCart = null;
      for (var j = 0; j < cart.items.length; j++) {
        if (cart.items[j].product_id === tier.productId) { inCart = cart.items[j]; break; }
      }
      var qualified = subtotal >= tier.threshold;
      var dismissed = sessionStorage.getItem('gift_dismissed_' + tier.productId);

      if (qualified && !inCart && !dismissed) {
        updates[tier.variantId] = 1;
        hasChanges = true;
      } else if (!qualified && inCart) {
        updates[inCart.variant_id] = 0;
        sessionStorage.removeItem('gift_dismissed_' + tier.productId);
        hasChanges = true;
      }
    }

    return hasChanges ? updates : null;
  },

  /**
   * Standalone sync for contexts where we can't batch (e.g. product-form add-to-cart).
   * Does its own fetch + update + re-render.
   */
  syncAfterAdd: async function() {
    try {
      var cart = await (await fetch('/cart.js')).json();
      var updates = this.getUpdates(cart);
      if (!updates) return;

      var cartDrawer = document.querySelector('cart-drawer');
      var sections = (cartDrawer && cartDrawer.getSectionsToRender)
        ? cartDrawer.getSectionsToRender().map(function(s) { return s.section; })
        : [];

      var body = { updates: updates };
      if (sections.length > 0) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      var res = await fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      var data = await res.json();

      if (cartDrawer && sections.length > 0) {
        cartDrawer.renderContents(data, false);
      }
    } catch(e) {}
  },

  dismissGift: function(productId) {
    sessionStorage.setItem('gift_dismissed_' + productId, '1');
  }
};

class FreeGiftElement extends HTMLElement {
  connectedCallback() {
    // On first load, do a standalone sync
    setTimeout(function() { window.GiftSync.syncAfterAdd(); }, 300);
  }
}
window.customElements.define('free-gift', FreeGiftElement);
